import * as Types from './types';

import gql from 'graphql-tag';
export type GameBetsQueryVariables = Types.Exact<{
  gameId: Types.Scalars['String']['input'];
  actor?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GameBetsQuery = { __typename?: 'Query', bets: Array<{ __typename?: 'Bet', rawAmount: string, rawPotentialPayout: string, result?: Types.BetResult | null, status: Types.BetStatus, isCashedOut: boolean, selections: Array<{ __typename?: 'Selection', rawOdds: string, outcome: { __typename?: 'Outcome', outcomeId: string, condition: { __typename?: 'Condition', conditionId: string, game: { __typename?: 'Game', gameId: string } } } }>, freebet?: { __typename?: 'Freebet', id: string } | null }>, liveBets: Array<{ __typename?: 'LiveBet', rawAmount: string, rawPotentialPayout: string, result?: Types.BetResult | null, status: Types.BetStatus, isCashedOut: boolean, selections: Array<{ __typename?: 'LiveSelection', outcome: { __typename?: 'LiveOutcome', outcomeId: string, condition: { __typename?: 'LiveCondition', conditionId: string } } }> }>, v3Bets: Array<{ __typename?: 'V3_Bet', rawAmount: string, rawPotentialPayout: string, result?: Types.BetResult | null, status: Types.BetStatus, isCashedOut: boolean, selections: Array<{ __typename?: 'V3_Selection', rawOdds: string, outcome: { __typename?: 'V3_Outcome', outcomeId: string, condition: { __typename?: 'V3_Condition', conditionId: string, gameId: string } } }>, freebet?: { __typename?: 'Freebet', id: string } | null }> };


export const GameBetsDocument = gql`
    query GameBets($gameId: String!, $actor: String) {
  bets(where: {_games_contains: [$gameId], actor: $actor}) {
    rawAmount
    rawPotentialPayout
    result
    status
    isCashedOut
    selections {
      rawOdds
      outcome {
        outcomeId
        condition {
          conditionId
          game {
            gameId
          }
        }
      }
    }
    freebet {
      id
    }
  }
  liveBets(where: {_gamesIds: [$gameId], actor: $actor}) {
    rawAmount
    rawPotentialPayout
    result
    status
    isCashedOut
    selections {
      outcome {
        outcomeId
        condition {
          conditionId
        }
      }
    }
  }
  v3Bets(where: {_gamesIds_contains: [$gameId], actor: $actor}) {
    rawAmount
    rawPotentialPayout
    result
    status
    isCashedOut
    selections {
      rawOdds
      outcome {
        outcomeId
        condition {
          conditionId
          gameId
        }
      }
    }
    freebet {
      id
    }
  }
}
    `;